import React from 'react';
import {
  Table,
  InputGroup,
  FormControl,
  Button,
  DropdownButton,
  Dropdown
} from 'react-bootstrap';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';

const searchableFields = [
  {
    keyName: 'nameCandidate',
    label: 'Candidato'
  },
  {
    keyName: 'nameInterviewer',
    label: 'Entrevistador'
  },
  {
    keyName: 'course',
    label: 'Curso'
  }
];

class Dashboard extends React.Component {
  constructor() {
    super();

    this.state = {
      answers: [],
      sortedAnswers: [],
      searchKey: '',
      searchValue: ''
    };

    this.getAnswers = this.getAnswers.bind(this);
    this.getCourseLabel = this.getCourseLabel.bind(this);
  }

  componentDidMount() {
    this.getAnswers();
  }

  async getAnswers() {
    const answers = await this.props.getAnswers(this.state);
    this.setState({ answers });
  }

  getSearchByLabel() {
    const { searchKey } = this.state;
    return _.get(
      _.filter(searchableFields, field => field.keyName === searchKey),
      '[0].label',
      'Selecione o campo'
    );
  }

  setsearchKey(searchKey) {
    this.setState({ searchKey });
  }

  setsearchValue(searchValue) {
    this.setState({ searchValue });
  }

  getCourseLabel(course) {
    const { courses = [] } = this.props;

    const courseLabel = _.filter(courses, ({ id }) => id === course);
    return (courseLabel && courseLabel[0] && courseLabel[0].label) || '-';
  }

  async sortBy(sortKey) {
    await this.setState(prevState => ({
      sortKey,
      sortDirection:
        prevState.sortDirection !== 'ascending' ? 'ascending' : 'descending'
    }));
    this.getAnswers();
  }

  render() {
    const { courses = [] } = this.props;
    const { answers = [] } = this.state;

    const aprovados = answers.filter(
      ans => ans.result >= 70 && ans.answers['question-2']
    ).length;
    const reprovados = answers.length - aprovados;
    const aderenciaTotal =
      (answers.length &&
        answers.reduce((acc, currentValue) => acc + currentValue.result, 0)) ||
      0;
    const aderenciaMedia = answers.length
      ? Math.round((aderenciaTotal / answers.length + Number.EPSILON) * 100) /
        100
      : 0;
    return (
      <>
        <InputGroup className="mb-3 mt-3 col-md-6 nopadding">
          <DropdownButton
            as={InputGroup.Prepend}
            variant="outline-secondary"
            title={this.getSearchByLabel()}
            id="input-group-dropdown-1"
          >
            {_.map(searchableFields, (field, index) => (
              <Dropdown.Item
                href="#"
                key={index}
                onClick={() => this.setsearchKey(field.keyName)}
              >
                {field.label}
              </Dropdown.Item>
            ))}
          </DropdownButton>
          <FormControl
            aria-describedby="basic-addon2"
            onChange={event =>
              this.setsearchValue(_.get(event, 'target.value'))
            }
          />
          <InputGroup.Append>
            <Button variant="outline-secondary" onClick={this.getAnswers}>
              Procurar
            </Button>
          </InputGroup.Append>
        </InputGroup>
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                Data{' '}
                <FontAwesomeIcon
                  icon={faSort}
                  onClick={() => this.sortBy('createdAt')}
                />
              </th>
              <th>
                Entrevistador(a){' '}
                <FontAwesomeIcon
                  icon={faSort}
                  onClick={() => this.sortBy('nameInterviewer')}
                />
              </th>
              <th>
                Candidato(a){' '}
                <FontAwesomeIcon
                  icon={faSort}
                  onClick={() => this.sortBy('nameCandidate')}
                />
              </th>
              <th>
                Curso{' '}
                <FontAwesomeIcon
                  icon={faSort}
                  onClick={() => this.sortBy('course')}
                />
              </th>
              <th>1.</th>
              <th>2.</th>
              <th>3.</th>
              <th>4.</th>
              <th>5.</th>
              <th>6.</th>
              <th>7.</th>
              <th>8.</th>
              <th>
                Taxa de aderência{' '}
                <FontAwesomeIcon
                  icon={faSort}
                  onClick={() => this.sortBy('result')}
                />
              </th>
              <th>Comentários</th>
            </tr>
          </thead>
          <tbody>
            {_.map(answers, (answer, index) => (
              <tr key={index}>
                <td>{answer.date}</td>
                <td>{answer.nameInterviewer}</td>
                <td
                  title={
                    (!answer.answers['question-2'] &&
                      'Precisa desenvolver atitude empática.') ||
                    ''
                  }
                  className={
                    ((answer.result < 70 || !answer.answers['question-2']) &&
                      'reprovado') ||
                    ''
                  }
                >
                  {`${answer.nameCandidate}${(!answer.answers['question-2'] &&
                    '*') ||
                    ''}`}
                </td>
                <td>{this.getCourseLabel(answer.course)}</td>
                {_.map(_.values(answer.answers), (value, indexQuestion) => (
                  <td
                    key={indexQuestion}
                    className={
                      (indexQuestion === 2 && !value && 'reprovado') || ''
                    }
                  >
                    {value}
                  </td>
                ))}
                <td>{answer.result}%</td>
                <td>{answer.comments}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>{answers.length} Participantes</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Aprovados</td>
              <td>{aprovados}</td>
            </tr>
            <tr>
              <td>Reprovados</td>
              <td>{reprovados}</td>
            </tr>
            <tr>
              <td>Pontuação Total</td>
              <td>{aderenciaTotal}</td>
            </tr>
            <tr>
              <td>Taxa de Aderência Média</td>
              <td className={(aderenciaMedia < 70 && 'reprovado') || ''}>
                {aderenciaMedia}%
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

export default Dashboard;
